import styled from 'styled-components';
import { ModalActions } from 'components/Modal';

export const ModalButtonActions = styled(ModalActions)`
  margin: auto;
  padding-bottom: 24px;
`;

export const ModalBodyHeader = styled.div`
    font-size: 24px;
    line-height: 33px;
    text-align: center;
    margin-top: 20px;
    font-weight: 600;
`;

export const ModalBodyText = styled.div`
    font-size: 14px;
    font-weight: 600;
    line-height: 19px;
    text-align: center;
    margin-top: 10px;
`;
